export default __webpack_public_path__ + "static/media/TakeRisk.821884af.pdf";